import React from 'react'
import ReactDOM from 'react-dom/client'
import '@gojek/typeface-maison-neue'
import 'index.css'
import 'utils/polyfills'
import App from 'App'
import { isDevelopment } from 'helpers/environment'

const currentPath = window.location.pathname

if (currentPath.startsWith('/user')) {
    import('utils/i18n/tsel')
} else {
    import('utils/i18n')
}

const renderApp = (): void => {
    const root = ReactDOM.createRoot(
        document.getElementById('root') as HTMLElement
    )
    root.render(
        <React.StrictMode>
            <App />
        </React.StrictMode>
    )
}

// Setup MSW mock service worker in development
if (isDevelopment()) {
    import('./mocks/browser').then(({ worker }) => {
        worker.start({ onUnhandledRequest: 'bypass' }).then(() => {
            renderApp()
        })
    })
} else {
    renderApp()
}
